import { CustomErrorPage } from 'components/molecules';
import React from 'react';


export default () => <CustomErrorPage />;